<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Data Karyawan</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Nama"
                  autofocus
                  required
                  v-model="formData.nama"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Status"
                  required
                  v-model="formData.status"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Telp"
                  required
                  v-model="formData.telp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Alamat"
                  required
                  v-model="formData.alamat"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Keterangan"
                  required
                  v-model="formData.ket"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="['Y', 'N']"
                  label="Aktif"
                  required
                  v-model="formData.is_active"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Tanggal Masuk"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="formData.tgl_masuk"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.tgl_masuk"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Tanggal Keluar"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="formData.tgl_keluar"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.tgl_keluar"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            :disabled="loading"
            tabindex="-1"
            @click="
              $emit('close-modal');
              resetFormData();
            "
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            :loading="loading"
            text
            @click="createData"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "CreateModal",
  props: ["openModal", "tempData"],
  data() {
    return {
      formData: {
        nama: "",
        status: "Marketing",
        alamat: "",
        telp: "",
        ket: "",
        is_active: "Y",
        tgl_masuk: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        tgl_keluar: ""
      },
      menu1: false,
      menu2: false,
      loading: false
    };
  },
  watch: {
    tempData(val) {
      if (val) {
        this.formData.nama = val;
      }
    }
  },
  methods: {
    async createData() {
      this.loading = true;

      await axios
        .post(`karyawan`, this.formData)
        .then(res => {
          this.loading = false;
          this.$emit("update-data", res.data);

          this.resetFormData();
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    resetFormData() {
      this.formData.nama = "";
      this.formData.status = "Marketing";
      this.formData.alamat = "";
      this.formData.telp = "";
      this.formData.ket = "";
      this.formData.is_active = "Y";
      this.formData.tgl_masuk = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.formData.tgl_keluar = "";
    }
  }
};
</script>
